var map = {
	"./line1.png": 895,
	"./line2.png": 8436,
	"./line3.png": 9565,
	"./line4.png": 6770,
	"./line5.png": 427,
	"./line6.png": 5024,
	"./line7.png": 777,
	"./line8.png": 8862
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5127;